import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/**
 * @route
 * @description app routing module will redirectTo login page if the session path is empty. this module will be called by app module when a sever starts.
 * 
 * 1. path: session:` will load the session module  
 * 2. path: '' : will redirectTo login page to access the project
 * 
 *  @see [Services]()
 */
const routes: Routes = [
  {
    path: '', // default path
    redirectTo: 'session/login',
    pathMatch: 'full'
  },
  {
    path: 'session', // session path
    loadChildren: "src/app/shared/session/session.module#SessionModule"
  },
  {
    path: 'prj/:fldr_Id/:fldr_ReusableFlag', // After successful login then it will be start from project module.
    loadChildren: "src/app/modules/fldrobject/fldrobject.module#FldrObjectModule"
  },
  {
    path: '**', // Page not found.
    loadChildren: "src/app/shared/httperrors/httperrors.module#HTTPErrorsModule"
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }